import React, { useEffect } from "react";
import "./DigitalVisibilityPlan.css";
import { useState } from "react";
import { Box } from "@mui/material";
import Register from "./Register";

const DigitalVisibilityPlan = () => {
  const [activePlan, setActivePlan] = useState("annual");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [paymentopen, setPaymentOpen] = useState(false);

  const fetchSubscriptionPlans = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PAYMENT_BACKEND_URL}/api/phonepe/plans`,
      );
      const data = await response.json();
      setSubscriptions(data.data);
      console.log("Fetched subscription plans:", data);
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
    }
  };

  useEffect(() => {
    fetchSubscriptionPlans();
  }, []);

  const getSelectedPlan = (name) => {
    const plan = subscriptions.find((p) => p.plan_name === name);

    if (!plan) return null;
    return {
      id: plan.id,
      name: plan.plan_name,

      monthlyPrice: Number(plan.quarterly_price) / 3,
      quarterlyPrice: Number(plan.quarterly_price),
      yearlyPrice: Number(plan.yearly_price),

      quarterly: `₹${(Number(plan.quarterly_price) / 3).toLocaleString("en-IN")} × 3`,
      annual: `₹${(Number(plan.yearly_price) / 10).toLocaleString("en-IN")} × 10`,
    };
  };

  return (
    <section className="dvp-wrapper">
      {/* Heading */}
      <div className="dvp-header-section">
        <div className="dvp-line"></div>

        <div className="dvp-heading-content">
          <h2 className="dvp-main-title">DIGITAL VISIBILITY PLAN</h2>
          <p className="dvp-sub-title">
            Website + Clinic/Hospital Management Software
          </p>
        </div>
        <div className="dvp-line"></div>
      </div>

      {/* Slider section start */}

      <div className="dvp-plan-tabs">
        <button
          className={activePlan === "monthly" ? "active" : ""}
          onClick={() => setActivePlan("monthly")}
        >
          <span className="full-text">Monthly</span>
          <span className="short-text">1Mon</span>
        </button>

        <button
          className={activePlan === "quarterly" ? "active" : ""}
          onClick={() => setActivePlan("quarterly")}
        >
          <span className="full-text">Quarterly</span>
          <span className="short-text">3Mon</span>
        </button>

        <button
          className={activePlan === "annual" ? "active" : ""}
          onClick={() => setActivePlan("annual")}
        >
          <span className="full-text">Annual</span>
          <span className="short-text">12Mon</span>
        </button>
      </div>

      <div key={activePlan} className="plan-content">
        {activePlan === "monthly" && (
          <div className="dvp-price-layout">
            <div className="dvp-price-card">
              <h3 className="dvp-price-heading">Monthly Plan</h3>
              <h1 className="dvp-price-amount">₹10,000 +</h1>
              <span className="dvp-price-month">₹3,999/month</span>
            </div>

            <div className="dvp-price-description">
              <p>
                Website and setup fee :<strong> ₹10,000/year</strong>.
                <br />
                <p>
                  Build your digital presence, streamline operations,
                  <br />
                  and grow your patient base.
                </p>
              </p>
            </div>

            <div className="btn-div">
              <button
                onClick={() => {
                  setSelectedPlan(getSelectedPlan("Digital Visibility"));
                  setPaymentOpen(true);
                }}
                className="lifetime-plan-btn"
              >
                Get Started
              </button>
            </div>
          </div>
        )}

        {activePlan === "quarterly" && (
          <div className="dvp-price-layout">
            <div className="dvp-price-card">
              <h3 className="dvp-price-heading">Quarterly Plan</h3>

              <h1 className="dvp-price-amount">
                ₹4,999 <span>x 3</span>
              </h1>
            </div>

            <div className="dvp-price-description">
              <p>
                Build your digital presence, streamline operations,
                <br />
                and grow your patient base.
              </p>
            </div>
            <div className="btn-div">
              <button
                onClick={() => {
                  setSelectedPlan(getSelectedPlan("Digital Visibility"));
                  setPaymentOpen(true);
                }}
                className="lifetime-plan-btn"
              >
                Get Started
              </button>
            </div>
          </div>
        )}

        {activePlan === "annual" && (
          <div className="dvp-price-layout annual-popular">
            <div className="dvp-price-card">
              <h3 className="dvp-price-heading">Annual Plan</h3>

              <h1 className="dvp-price-amount">
                ₹3,999 <span>x 12</span>
              </h1>
            </div>

            <div className="dvp-price-description">
              <p>
                Build your digital presence, streamline operations,
                <br />
                and grow your patient base.
              </p>
            </div>
            <div className="btn-div">
              <button
                onClick={() => {
                  setSelectedPlan(getSelectedPlan("Digital Visibility"));
                  setPaymentOpen(true);
                }}
                className="lifetime-plan-btn"
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Slider section end */}

      {/* Cards */}

      <div className="dvp-grid-layout">
        {/* LEFT */}

        <div className="dvp-info-card">
          <div className="dvp-card-top">
            <lord-icon
              src="/animations/digital/computer.json"
              trigger="loop"
              delay="2000"
              style={{ width: "55px", height: "55px" }}
            ></lord-icon>

            <div>
              <h3 className="dvp-card-title">WHAT'S INCLUDED</h3>

              <p className="dvp-card-subtext">
                Everything you need to grow digitally & efficiently.
              </p>
            </div>
          </div>

          <div className="dvp-card-section">
            <h4 className="dvp-section-heading">1. WEBSITE</h4>

            <ul className="dvp-list">
              <li>Professional, Mobile-Friendly Website</li>
              <li>SEO-Optimized Pages</li>
              <li>Contact Forms & Click-to-Call</li>
              <li>Google Maps Integration</li>
              <li>SSL Certificate & Basic Security</li>
              <li>Website Hosting & Maintenance</li>
            </ul>
          </div>

          <div className="dvp-card-section">
            <h4 className="dvp-section-heading">
              2. CLINIC / HOSPITAL MANAGEMENT SOFTWARE
            </h4>

            <ul className="dvp-list">
              <li>Appointment Scheduling</li>
              <li>Patient Registration & Records</li>
              <li>OPD Management</li>
              <li>Billing & Invoicing</li>
              <li>Prescription Management</li>
              <li>Inventory Management</li>
              <li>Staff & Role Management</li>
              <li>Reports & Analytics Dashboard</li>
            </ul>
          </div>
        </div>

        {/* RIGHT */}

        <div className="dvp-info-card">
          <div className="dvp-card-top">
            <lord-icon
              src="/animations/digital/marketing.json"
              trigger="loop"
              delay="2000"
              style={{ width: "55px", height: "55px" }}
            ></lord-icon>

            <div>
              <h3 className="dvp-card-title">DIGITAL VISIBILITY & MARKETING</h3>

              <p className="dvp-card-subtext">
                Get discovered, build trust and attract more patients.
              </p>
            </div>
          </div>

          <div className="dvp-card-section">
            <h4 className="dvp-section-heading">
              3. PROFILE OPTIMIZATION & MANAGEMENT
            </h4>

            <ul className="dvp-list">
              <li>Google My Business (GMB)</li>
              <li>Website</li>
              <li>LinkedIn</li>
              <li>Instagram</li>
              <li>Facebook</li>
              <li>YouTube</li>
            </ul>
          </div>

          <div className="dvp-card-section">
            <h4 className="dvp-section-heading">4. CONTENT & MARKETING</h4>

            <ul className="dvp-list">
              <li>Design of 12 Creatives for Social Media Every Month</li>
              <li>
                12 Reel Videos per Year (1 Reel per Month, up to 60 Seconds
                Each)
              </li>
              <li>1 Ad Campaign Management Per Month</li>
            </ul>
          </div>

          <div className="dvp-card-section">
            <h4 className="dvp-section-heading">5. ADD-ONS</h4>

            <ul>
              <li>
                Each service starts at ₹3,000 - Video Editing, AI Clone Videos &
                Shoot Services (2 videos, 30 seconds each).
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Register
        open={paymentopen}
        onClose={() => setPaymentOpen(false)}
        selectedPlan={selectedPlan}
      />
    </section>
  );
};

export default DigitalVisibilityPlan;
